import base from '../dr-base'
import drBaseActions from '../dr-base-actions'
import drFileViewer from './dr-file-viewer.vue'

const schema = {
  $Type: 'dr-file-viewer',
  name: 'File viewer',
  group: 'Advanced',
  icon: 'file-search',
  ...base,
  properties: {
    ...base.properties,
    /*
    ** { type: 'pdf', name: 'myFile', 'https://myFile.pdf' }
    */
    FileSource: {
      name: 'vuetifyWidgets.dr-file-viewer.fileSource',
      type: 'string',
      default: '',
      HintText: 'vuetifyWidgets.dr-file-viewer.fileDataFormat'
    },
    // формат: 300px
    Width: {
      name: 'vuetifyWidgets.dr-file-viewer.width',
      type: 'string'
    },
    // формат: 300px
    Height: {
      name: 'vuetifyWidgets.dr-file-viewer.height',
      type: 'string'
    },
    NewPdfViewer: {
      type: 'boolean',
      name: 'vuetifyWidgets.dr-file-viewer.newPdfViewer',
      default: false
    },
    UsePdfViewerForOldVersionIOS: {
      type: 'boolean',
      name: 'vuetifyWidgets.dr-file-viewer.usePdfViewerForOldVersionIOS',
      default: false
    },
    GenerationOnLastPageReached: {
      ...drBaseActions.properties.OnClickAction,
      name: 'vuetifyWidgets.dr-file-viewer.generationOnLastPageReached',
      component: 'dr-prop-action',
      properties: { 
        ...drBaseActions.properties.OnClickAction.properties,
        Type: {
          name: 'vuetifyWidgets.dr-button.type',
          type: 'string',
          enum: [
            {
              value: 'dataSourceAction',
              text: 'Data Source Action'
            },
            {
              value: 'RunJsAction',
              text: 'vuetifyWidgets.drPropAction.runJsAction'
            }
          ]
        } 
      }
    }
  }
}

export default {
  schema,
  component: drFileViewer,
  propEditors: [
    {
      name: 'dr-prop-action'
    }
  ]
}
